import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import "./ChatMessage.css";

function escapeHtml(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function renderInline(text) {
  // Links first: [label](https://...) becomes a new-tab anchor.
  const linked = text.replace(
    /\[([^\]]+)\]\((https?:[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noreferrer">$1</a>'
  );
  // Regular expression to match **text**
  // Replace **text** with <strong>text</strong>
  return linked.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
}

function renderMarkdown(text) {
  // Blank-line separated blocks: headings, bullet lists, paragraphs.
  // Single newlines inside a paragraph stay soft breaks.
  return escapeHtml(text)
    .split(/\n\s*\n/)
    .map((block) => {
      const lines = block
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
      if (lines.length === 0) return "";
      const heading = lines[0].match(/^#{1,6}\s+(.*)$/);
      if (heading && lines.length === 1) {
        return `<div class="md-h">${renderInline(heading[1])}</div>`;
      }
      if (lines.every((line) => /^[-*]\s+/.test(line))) {
        const items = lines
          .map((line) => `<li>${renderInline(line.replace(/^[-*]\s+/, ""))}</li>`)
          .join("");
        return `<ul class="msg-list">${items}</ul>`;
      }
      return `<p class="msg-p">${lines.map(renderInline).join("<br />")}</p>`;
    })
    .join("");
}

const ChatMessage = ({ sender, text }) => {
  const [copied, setCopied] = useState(false);
  const parsedText = renderMarkdown(text);

  const copyResponse = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable — stay quiet */
    }
  };

  if (sender === "user") {
    return (
      <div className="message user">
        <div className="message-content">
          <div className="msg-body" dangerouslySetInnerHTML={{ __html: parsedText }}></div>
        </div>
      </div>
    );
  }

  return (
    <div className="message bot">
      <span className="bot-mark" aria-hidden="true">
        <img src="/images/vai-avatar.jpg" alt="" />
      </span>
      <div className="bot-body">
        {text === "..." ? (
          <div className="typing-indicator" aria-label="vAI is typing">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        ) : (
          <div className="message-content">
            <div className="msg-body" dangerouslySetInnerHTML={{ __html: parsedText }}></div>
          </div>
        )}
        {text !== "..." && (
          <button
            className="copy-button"
            onClick={copyResponse}
            aria-label={copied ? "Copied" : "Copy response"}
          >
            {copied ? <Check size={14} /> : <Copy size={14} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
